import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenService } from '../service/token.service';
import { ServiceDeliveryBacklogDetailInfo } from '../model/ServiceDeliveryBacklogDetailInfo.model';
import { ProjectSaleQuotationInfo } from 'src/app/model/ProjectSaleQuotationInfo.model';
import { ProductInfo } from '../model/ProductInfo.model';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import { AbstractControl, ValidatorFn,ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-service-delivery-backlog-detail',
  templateUrl: './service-delivery-backlog-detail.component.html',
  styleUrls: ['./service-delivery-backlog-detail.component.css']
})
export class ServiceDeliveryBacklogDetailComponent implements OnInit {
  baseurl: string = '';
  loading: boolean = false;
  environment: number = 10;
  currentPageNumber: number = 1;
  totalPages: number = 1;
  totalItems: number = 0;

  form: FormGroup;
  formCloseActualDate: FormGroup;
  canEdit: boolean = true;
  isOnUpdate: boolean = false;
  
  ServiceDeliveryBacklogProjectSaleCode: string = '';
  ServiceDeliveryBacklogProjectSaleName: string = '';
  ServiceDeliveryBacklogID_String: string; // Value is ProjectSaleID
  ServiceDeliveryBacklogID: number

  ServiceDeliveryBacklogDetailList: ServiceDeliveryBacklogDetailInfo[] = [];
  BacklogDetailAvailablePriceList: ServiceDeliveryBacklogDetailInfo[] = [];
  TotalBacklogDetailDeliveredQuotationList: ServiceDeliveryBacklogDetailInfo[] = [];

  ProjectSaleQuotationList: ProjectSaleQuotationInfo[] = []
  hidProjectSaleQuotationID: number;
  isSubmitted: any;

  //maxAllowedPrice: number = 0;
  //maxAllowedPriceShow: number = 0;
  maxAllowedQuotationPrice: number = 0 ;
  currentEditingBacklogId: number | null = null;

  formattedPrice: string = '';
  showActualDate = false;
  isShowModalProductModal = false;
  showQuotationChanged = false;
  QuotationPriceShow: number = 0;
  DeliveredPriceShow: number = 0;

  estimateActualDateValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
  const estimateDate = control.get('ServiceDeliveryBacklogDetailEstimateDate')?.value;
  const actualDate = control.get('ServiceDeliveryBacklogDetailActualDate')?.value;

  if (!actualDate) return null;
  if (!estimateDate) return { estimateRequired: true };

  const est = new Date(estimateDate);
  const act = new Date(actualDate);

  if (act < est) return { actualBeforeEstimate: true };

  return null;
};

  // Part Product
  currentPageNumberPrduct: number = 1;
  totalPagesProduct: number;
  ProductList: ProductInfo[] = [];
  SelectedProductList: ProductInfo[] = [];
  ProjectSaleItemList: ProjectSaleInfo[] = [];
  ProjectSaleAssetTypeList: AssetTypeInfo[] = [];

  txtSearchProductCode: string = '';
  txtSearchProductName: string = '';
  txtSearchProductLicensePlate: string = '';
  txtSearchProductChassisNo: string = '';

  ProductGroupShow: string = '';
  ProductCategoryCode: string = '';
  ProductTypeCode: string = '';
  ProductCategoryShow: string = '';
  ProductTypeShow: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private TokenService: TokenService,
    private formBuilder: FormBuilder,
    private location: Location,
    @Optional() private dialogRef: MatDialogRef<ServiceDeliveryBacklogDetailComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { 
    this.baseurl = environment.base_api;
  }

  async ngOnInit(): Promise<void> {
    // const calculateAndSetMaxPrice = async () => {
    //   if (this.ServiceDeliveryBacklogProjectSaleCode) {
    //     await this.CalculateAcutalPriceAvailable(this.ServiceDeliveryBacklogProjectSaleCode);
    //     await this.getActualRemainingPriceForDisplay(this.ServiceDeliveryBacklogProjectSaleCode);
    //   } else {
    //     console.warn('Project Sale Code is not available. Cannot calculate initial max allowed price.');
    //   }
    // };

    // Check if component is opened as a dialog
    if (this.dialogData) {
      this.ServiceDeliveryBacklogProjectSaleCode = this.dialogData.ServiceDeliveryBacklogProjectSaleCode;
      this.ServiceDeliveryBacklogProjectSaleName = this.dialogData.ServiceDeliveryBacklogProjectSaleName;
      this.ServiceDeliveryBacklogID_String = this.dialogData.ServiceDeliveryBacklogID;

      //calculateAndSetMaxPrice();
    } else {
      // Fallback to route params if not opened as dialog
        this.route.queryParamMap.subscribe(async params => {
        this.ServiceDeliveryBacklogProjectSaleCode = params.get('ServiceDeliveryBacklogProjectSaleCode');
        this.ServiceDeliveryBacklogProjectSaleName = params.get('ServiceDeliveryBacklogProjectSaleName');
        this.ServiceDeliveryBacklogID_String = params.get('ServiceDeliveryBacklogID');

        //calculateAndSetMaxPrice();
      });
    }

    this.ServiceDeliveryBacklogID = parseInt(this.ServiceDeliveryBacklogID_String ?? '0', 10);

    setTimeout(() => {
    if (!this.ServiceDeliveryBacklogProjectSaleCode) {
      this.router.navigate(['/service-delivery-backlog']);
    } else {
      // Do nothing;
    }
  });
    
    this.getServiceDeliveryBacklogDetailList();

    this.form = this.formBuilder.group({
      ServiceDeliveryBacklogDetailID: [0],
      ServiceDeliveryBacklogDetailProjectSaleCode: [null], // new
      ServiceDeliveryBacklogDetailBacklogNo: [null], // new
      ServiceDeliveryBacklogDetailDeliveryStatus: [null], // new
      ServiceDeliveryBacklogDetailBacklogDesc: [null, Validators.required],
      ServiceDeliveryBacklogDetailEstimateDate: [null],
      //ServiceDeliveryBacklogDetailActualDate: [this.getTodayDateTH(), Validators.required],
      ServiceDeliveryBacklogDetailActualDate: [null],
      //ServiceDeliveryBacklogDetailPrice: [null, [Validators.required, Validators.min(0)]],
      ServiceDeliveryBacklogDetailPrice: [null,[
        Validators.required, // ยังคงต้องการให้กรอกค่า
        Validators.min(0),
        this.maxQuotationPriceValidator()    // ยังคงต้องการให้ค่าไม่น้อยกว่า 0
      ]],
      ServiceDeliveryBacklogDetailCreateDate: [null], // new
      ServiceDeliveryBacklogDetailCreateBy: [null], // new
      ServiceDeliveryBacklogDetailUpdateDate: [null], // new
      ServiceDeliveryBacklogDetailUpdateBy: [null],
      ServiceDeliveryBacklogDetailRequireDate: [null],
      ServiceDeliveryBacklogDetailContractDate: [null],
      ProjectSaleQuotationID: [null],
      ProjectSaleQuotationNo:[null, Validators.required], // new
      FlagUpdProjectSaleQuotation: [null]
    },{
      //validators: this.estimateActualDateValidator  //
    });

    this.formCloseActualDate = this.formBuilder.group({
      ServiceDeliveryBacklogDetailActualDateClose: [null, Validators.required]
    });

    this.form.get('ServiceDeliveryBacklogDetailContractDate')?.valueChanges.subscribe(value => {
    this.showActualDate = value != null && value !== '';
  
    if (this.showActualDate) {
      const actualDateControl = this.form.get('ServiceDeliveryBacklogDetailActualDate');
      actualDateControl?.enable();
      }});
      
      await this.LoadProjectSaleQuotationList();
      await this.LoadProjectSaleItemList();
    }

  getTodayDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0]; // คืนค่า '2025-05-28' เช่น
  }

  getTodayDateTH(): string {
    const today = new Date();
    const offsetMs = 7 * 60 * 60 * 1000; // 7 ชั่วโมง (UTC+7)
    const localDate = new Date(today.getTime() + offsetMs);
    return localDate.toISOString().split('T')[0]; // ได้ 'YYYY-MM-DD'
  }

  compareEstimateVsActual(estimate: string | null, actual: string | null): string {

    return actual ? '2' : '1'; // ถ้า actual date มีค่า ให้ return '2' (แสดงว่า actual date ถูกกรอกแล้ว) ถ้าไม่มีค่า ให้ return '1' (แสดงว่า actual date ยังไม่ถูกกรอก)
}

  async getServiceDeliveryBacklogDetailList() {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      console.log('currentPageNumber', this.currentPageNumber);
      console.log('environment', this.environment);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        ServiceDeliveryBacklogDetailProjectSaleCode: this.ServiceDeliveryBacklogProjectSaleCode,
        rowFetch: this.environment,
        rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * this.environment
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "ServiceDeliveryBacklog/GetServiceDeliveryBacklogDetail",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ServiceDeliveryBacklogDetailList = response;
      this.totalItems = this.ServiceDeliveryBacklogDetailList.length;

      if (this.ServiceDeliveryBacklogDetailList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.ServiceDeliveryBacklogDetailList[0].itemTotal);
      }

      this.totalPages = Math.ceil(this.totalItems / this.environment);
    } catch (error) {
      console.error('Error loading service delivery backlog detail:', error);
      alert('An error occurred while loading service delivery backlog detail data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  LoadServiceDeliveryBacklogDetailList(target = null) {
    if (target != null) {
      this.currentPageNumber = target.currentPageNumber;
      this.totalPages = target.totalPages;
    }

    this.getServiceDeliveryBacklogDetailList();
  }

  chkallclick(event: any): void {
    const isChecked = event.target.checked;
    const checkboxes = document.getElementsByName('checkboxServiceDeliveryBacklogDetailID') as NodeListOf<HTMLInputElement>;

    checkboxes.forEach((checkbox) => {
    checkbox.checked = isChecked;
    });
  }

  async btnClick_onCreateServiceDeliveryBacklogDetail() {
    this.isOnUpdate = false;
    this.Clearinput();
    this.currentEditingBacklogId = null;
    this.showQuotationChanged = false;

    this.showActualDate = false;

    this.form.reset();

    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.form.updateValueAndValidity();

    //await this.CalculateAcutalPriceAvailable(this.ServiceDeliveryBacklogProjectSaleCode);
    //const formattedMaxPrice = this.formatPrice(this.maxAllowedPrice);
    //this.form.get('ServiceDeliveryBacklogDetailPrice')?.setValue(formattedMaxPrice, { emitEvent: false });

    // setTimeout(() => {
    // const $modal = $('#ModalServiceDeliveryDetail');
    // $modal.modal('dispose'); 
    // $modal.modal({ backdrop: false, keyboard: false });
    // $modal.modal('show');
    // }, 0);
    $('#ModalServiceDeliveryDetail').modal('show');
  }

  Clearinput() {
    this.form.patchValue({
      ServiceDeliveryBacklogDetailID: 0,
      ServiceDeliveryBacklogDetailBacklogNo: null,
      ServiceDeliveryBacklogDetailDeliveryStatus: null,
      ServiceDeliveryBacklogDetailBacklogDesc: null,
      ServiceDeliveryBacklogDetailEstimateDate: null,
      //ServiceDeliveryBacklogDetailActualDate: this.getTodayDateTH(),
      ServiceDeliveryBacklogDetailActualDate: null,
      ServiceDeliveryBacklogDetailRequireDate: null,
      ServiceDeliveryBacklogDetailContractDate: null,
      ServiceDeliveryBacklogDetailPrice: null
    });
  }

  async btnClick_onUpdateServiceDeliveryBacklogDetail(serviceDeliveryBacklogDetailID: number) {
    try {
      const serviceDeliveryBacklogDetail = this.ServiceDeliveryBacklogDetailList.find(x => x.ServiceDeliveryBacklogDetailID === serviceDeliveryBacklogDetailID);
      if (serviceDeliveryBacklogDetail) {
        this.isOnUpdate = true;
        this.currentEditingBacklogId = serviceDeliveryBacklogDetailID; // เก็บ ID ของรายการที่กำลังแก้ไข

        const formatDate = (value: string | null): string | null => {
        if (!value) return null;
        return new Date(value).toISOString().split('T')[0];
      };

      this.showActualDate = true;

    // ถ้า formControl ควรเปิด/ปิดตามด้วย:
    const actualDateControl = this.form.get('ServiceDeliveryBacklogDetailActualDate');
    if (this.showActualDate) {
      actualDateControl?.enable();
    } else {
      actualDateControl?.disable(); // ปิด validation และ field
    }

        this.form.patchValue({
          ServiceDeliveryBacklogDetailID: serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailID,
          ServiceDeliveryBacklogDetailProjectSaleCode: this.ServiceDeliveryBacklogProjectSaleCode,
          ServiceDeliveryBacklogDetailBacklogNo: serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailBacklogNo,
          ServiceDeliveryBacklogDetailBacklogDesc: serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailBacklogDesc,
          ServiceDeliveryBacklogDetailEstimateDate: formatDate(serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailEstimateDate),
          ServiceDeliveryBacklogDetailActualDate: formatDate(serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailActualDate),
          //ServiceDeliveryBacklogDetailPrice: serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailPrice,
          ServiceDeliveryBacklogDetailDeliveryStatus: serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailDeliveryStatus,
          ServiceDeliveryBacklogDetailRequireDate: formatDate(serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailRequireDate),
          ServiceDeliveryBacklogDetailContractDate: formatDate(serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailContractDate),
          ProjectSaleQuotationNo: serviceDeliveryBacklogDetail.ProjectSaleQuotationNo
        });

        const initialQuoNo = this.form.get('ProjectSaleQuotationNo')?.value;
          if (initialQuoNo) {
        const initialEvent = { target: { value: initialQuoNo } };
        await this.ddlProjectSaleQuotationCodeChange(initialEvent as any);
          }
          
        const rawPrice = serviceDeliveryBacklogDetail.ServiceDeliveryBacklogDetailPrice;
        const formatted = this.formatPrice(rawPrice);
        this.form.get('ServiceDeliveryBacklogDetailPrice')?.setValue(formatted, { emitEvent: false });
        console.log('btnClick_onUpdate: ตั้งค่า ServiceDeliveryBacklogDetailPrice ใน form control จาก DB:', this.form.get('ServiceDeliveryBacklogDetailPrice')?.value);

        // <<-- แทนที่จะเรียก ddlProjectSaleQuotationCodeChange ให้เรียก getRemainingQuotationPrice ตรงๆ -->>
        if (serviceDeliveryBacklogDetail.ProjectSaleQuotationNo) { // ตรวจสอบว่ามี QuotationNo ก่อนเรียก
          await this.getRemainingQuotationPrice(this.ServiceDeliveryBacklogProjectSaleCode, serviceDeliveryBacklogDetail.ProjectSaleQuotationNo);
          console.log('btnClick_onUpdate: เรียก getRemainingQuotationPrice โดยตรงสำหรับ Quotation:', serviceDeliveryBacklogDetail.ProjectSaleQuotationNo);
        }
        
        // กระตุ้นการ Validate ช่องราคาอีกครั้ง เพื่อให้ใช้ maxAllowedQuotationPrice ใหม่
        this.form.get('ServiceDeliveryBacklogDetailPrice')?.updateValueAndValidity();

        // setTimeout(() => {
        //   const $modal = $('#ModalServiceDeliveryDetail');
        //   $modal.modal('dispose'); 
        //   $modal.modal({ backdrop: false, keyboard: false });
        //   $modal.modal('show');
        // }, 0);
        $('#ModalServiceDeliveryDetail').modal('show');
      }
    } catch (error) {
      console.error('Error updating service backlog:', error);
      alert('An error occurred while updating service backlog. Please try again.');
    }
  }

  async btnSave() {

    // ส่วนที่แก้ Format Price
    Object.keys(this.form.controls).forEach(key => {
    const control = this.form.get(key);
    if (control && control.invalid) {
      //console.warn(`Field "${key}" is invalid:`, control.errors);
      }
    });
    // ส่วนที่แก้ Format Price

    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) {
      this.validateAllFormFields(this.form);
      return;
    }    

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const formData = this.form.value;

    if (typeof formData.ServiceDeliveryBacklogDetailPrice === 'string' && formData.ServiceDeliveryBacklogDetailPrice !== null) {
    formData.ServiceDeliveryBacklogDetailPrice = this.parseFormattedPrice(formData.ServiceDeliveryBacklogDetailPrice);
  }

    formData.ServiceDeliveryBacklogDetailDeliveryStatus = this.compareEstimateVsActual(
        formData.ServiceDeliveryBacklogDetailEstimateDate, formData.ServiceDeliveryBacklogDetailActualDate
    );

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      // Set CreateBy and UpdateBy based on operation type
      if (this.isOnUpdate) {
        // Update
        formData.ServiceDeliveryBacklogDetailID = formData.ServiceDeliveryBacklogDetailID;
        formData.ServiceDeliveryBacklogDetailDeliveryStatus = formData.ServiceDeliveryBacklogDetailDeliveryStatus;
        formData.ServiceDeliveryBacklogDetailBacklogDesc = formData.ServiceDeliveryBacklogDetailBacklogDesc;
        formData.ServiceDeliveryBacklogDetailEstimateDate = formData.ServiceDeliveryBacklogDetailEstimateDate;
        formData.ServiceDeliveryBacklogDetailActualDate = formData.ServiceDeliveryBacklogDetailActualDate;
        formData.ServiceDeliveryBacklogDetailPrice = formData.ServiceDeliveryBacklogDetailPrice;
        formData.ServiceDeliveryBacklogDetailRequireDate = formData.ServiceDeliveryBacklogDetailRequireDate;
        formData.ServiceDeliveryBacklogDetailContractDate = formData.ServiceDeliveryBacklogDetailContractDate;
        formData.ProjectSaleQuotationID = this.hidProjectSaleQuotationID;
        formData.ProjectSaleQuotationNo = formData.ProjectSaleQuotationNo;
        formData.ServiceDeliveryBacklogDetailUpdateBy = localStorage.getItem("EmpCode");
        formData.FlagUpdProjectSaleQuotation = "Y";
        console.log('formDataValue:', formData);
      } else {
        // Create
        formData.ServiceDeliveryBacklogDetailID = 0;
        formData.ServiceDeliveryBacklogDetailProjectSaleCode = this.ServiceDeliveryBacklogProjectSaleCode;
        //formData.ServiceDeliveryBacklogDetailBacklogNo = ""; // Find Value at API
        formData.ServiceDeliveryBacklogDetailDeliveryStatus = formData.ServiceDeliveryBacklogDetailDeliveryStatus;
        formData.ServiceDeliveryBacklogDetailBacklogDesc = formData.ServiceDeliveryBacklogDetailBacklogDesc;
        formData.ServiceDeliveryBacklogDetailEstimateDate = formData.ServiceDeliveryBacklogDetailEstimateDate;
        formData.ServiceDeliveryBacklogDetailActualDate = formData.ServiceDeliveryBacklogDetailActualDate;
        formData.ServiceDeliveryBacklogDetailPrice = formData.ServiceDeliveryBacklogDetailPrice;
        formData.ServiceDeliveryBacklogDetailRequireDate = formData.ServiceDeliveryBacklogDetailRequireDate;
        formData.ServiceDeliveryBacklogDetailContractDate = formData.ServiceDeliveryBacklogDetailContractDate;
        formData.ProjectSaleQuotationID = this.hidProjectSaleQuotationID;
        formData.ProjectSaleQuotationNo = formData.ProjectSaleQuotationNo;
        formData.FlagUpdProjectSaleQuotation = "Y";
        formData.ServiceDeliveryBacklogDetailCreateBy = localStorage.getItem("EmpCode");
        console.log('formDataValue:', formData);
      }

      const response = await this.httpClient.post<any>(
        this.baseurl + "ServiceDeliveryBacklog/InsertUpdateServiceDeliveryBacklogDetail",
        JSON.stringify(formData),
        httpOptions
      ).toPromise();

      if (response === true) {
        this.Clearinput();
        await this.getServiceDeliveryBacklogDetailList();
        //await this.CalculateAcutalPriceAvailable(this.ServiceDeliveryBacklogProjectSaleCode);
        //await this.getActualRemainingPriceForDisplay(this.ServiceDeliveryBacklogProjectSaleCode);
        $('#ModalServiceDeliveryDetail').modal('hide');
        
        // Show success message
        const message = this.isOnUpdate ? 'Service delivery backlog detail updated successfully' : 'Service delivery backlog detail created successfully';

        setTimeout(() => {alert(message);}, 500);
        //alert(message);
      } else {
        // Handle unsuccessful response
        console.error('Save failed');
        alert('Failed to save service delivery backlog detail');
      }

      } catch (error) {
      console.error('Error saving service delivery backlog detail:', error);
      alert('An error occurred while saving service delivery backlog detail. Please try again.');
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  async btnClick_onDeleteServiceDeliveryBacklogDetail() {
    const checkedBoxes = document.querySelectorAll<HTMLInputElement>(
    'input[name="checkboxServiceDeliveryBacklogDetailID"]:checked'
  );

  const selectedIDs: number[] = Array.from(checkedBoxes).map((checkbox) =>
    Number(checkbox.value)
  );

  // Console log ID ที่ checkbox ถูก checked
  console.log('Checked IDs:', selectedIDs);

  if (selectedIDs.length === 0) {
    alert('กรุณาเลือกอย่างน้อยหนึ่งรายการเพื่อลบ');
    return;
  }

  const confirmDelete = confirm(`คุณต้องการลบ ${selectedIDs.length} รายการใช่หรือไม่?`);
  if (!confirmDelete) return;

  this.loading = true;

  try {
  const auth_token = await this.TokenService.RefreshToken();
  if (!auth_token) {
    alert('Session หมดอายุ กรุณาเข้าสู่ระบบใหม่');
    return;
  }

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };
  const payload = { ids: selectedIDs };
  console.log('Sending to delete API:', payload);

    // ส่วน Call API Delete 
    const response = await this.httpClient.post<boolean>(
      this.baseurl + 'ServiceDeliveryBacklog/DeleteServiceDeliveryBacklogDetail',
      payload,
      httpOptions
    ).toPromise();

    if (response === true) {
      alert('ลบรายการสำเร็จ');
      await this.getServiceDeliveryBacklogDetailList(); // Reload List
      //await this.CalculateAcutalPriceAvailable(this.ServiceDeliveryBacklogProjectSaleCode);
      //await this.getActualRemainingPriceForDisplay(this.ServiceDeliveryBacklogProjectSaleCode);
      $('#ModalServiceDeliveryDetail').modal('hide');
    } else {
      alert('ลบไม่สำเร็จ กรุณาลองใหม่');
    }
    
    } catch (error) {
      console.error('Error deleting:', error);
      alert('ไม่สามารถลบข้อมูลได้ โปรดลองใหม่อีกครั้ง');
    } finally {
      this.loading = false;
    }
  }

  GoBack() {
    this.location.back()
  }

  btnClick_onBack() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.location.back();
    }
  }
  
  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onPriceInput(event: Event) {

    const input = event.target as HTMLInputElement;
    let rawValue = input.value;

    rawValue = rawValue.replace(/[^0-9.]/g, '');

    // No format value but set raw to form
    this.form.get('ServiceDeliveryBacklogDetailPrice')?.setValue(rawValue, { emitEvent: false });
  }

  onPriceBlur01() {
    // ส่วนที่แก้ Format Price
    //const value = this.form.get('ServiceDeliveryBacklogDetailPrice')?.value;
    //this.formattedPrice = this.formatPrice(value);
    const control = this.form.get('ServiceDeliveryBacklogDetailPrice');
    const value = control?.value;

    if (value != null && value !== '') {
      const number = parseFloat(value);
    if (!isNaN(number)) {
      const formatted = this.formatPrice(number);
      control?.setValue(formatted, { emitEvent: false });
      }
    }
    // ส่วนที่แก้ Format Price
  }

  onPriceBlur() {
  const control = this.form.get('ServiceDeliveryBacklogDetailPrice');
  const raw = control?.value;

  if (raw != null && raw !== '') {
    const cleaned = raw.toString().replace(/,/g, ''); // ลบ comma ก่อน
    const number = parseFloat(cleaned);

      if (!isNaN(number)) {
        const formatted = this.formatPrice(number);
        control?.setValue(formatted, { emitEvent: false });
        control.updateValueAndValidity();
      } else {
        control.setValue(null); 
        control.updateValueAndValidity();
      } 
  } else if (control) {
    control.updateValueAndValidity(); 
    }
  }

  formatPrice(value: number | string): string {
  if (value == null || value === '') return '';
    const num = +value;
    return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    });
  }

  async btnClick_onUpdateAllCloseDeliveryBacklogDetail() {
    const checkedBoxes = document.querySelectorAll<HTMLInputElement>(
    'input[name="checkboxServiceDeliveryBacklogDetailID"]:checked'
  );

  const selectedIDs: number[] = Array.from(checkedBoxes).map((checkbox) =>
    Number(checkbox.value)
  );

  // Console log ID ที่ checkbox ถูก checked
  console.log('Checked IDs:', selectedIDs);

  if (selectedIDs.length === 0) {
    alert('กรุณาเลือกอย่างน้อยหนึ่งรายการเพื่อ Close');
    return;
  } 
  
  setTimeout(() => {
    const $modal = $('#ModalCloseActualDateServiceDeliveryDetail');
    $modal.modal({ backdrop: false, keyboard: false });
    $modal.modal('show');
  }, 0);
  }

  async btnSaveCloseActualDate() {
    this.formCloseActualDate.markAllAsTouched();
    this.formCloseActualDate.updateValueAndValidity();

    if (this.formCloseActualDate.invalid) {
      this.validateAllFormFields(this.formCloseActualDate);
      return;
    }    
    
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const checkedBoxes = document.querySelectorAll<HTMLInputElement>(
      'input[name="checkboxServiceDeliveryBacklogDetailID"]:checked'
    );

    const actualDate = this.formCloseActualDate.get('ServiceDeliveryBacklogDetailActualDateClose').value;
    const selectedCloseIDs: number[] = Array.from(checkedBoxes).map((checkbox) =>
    Number(checkbox.value)
  );

    console.log('actualDate:', actualDate);
    console.log('Checked IDs for Close:', selectedCloseIDs);

    const payload = { 
      ids: selectedCloseIDs,
      actualDate: actualDate
    };
    console.log('Sending to Close API:', payload);

    this.loading = true;

    try {
      const response = await this.httpClient.post<boolean>(
        this.baseurl + 'ServiceDeliveryBacklog/CloseAllServiceDeliveryBacklogDetail',
        payload,
        httpOptions
      ).toPromise();

      if (response === true) {
      alert('Close รายการสำเร็จ');
      await this.getServiceDeliveryBacklogDetailList();
      //await this.CalculateAcutalPriceAvailable(this.ServiceDeliveryBacklogProjectSaleCode);
      $('#ModalCloseActualDateServiceDeliveryDetail').modal('hide');
      }

      } catch (error) {
      console.error('Error closing:', error);
    alert('ไม่สามารถ Close ข้อมูลได้ โปรดลองใหม่อีกครั้ง');
    } finally {
      this.loading = false;//
    }
  }

  async openModalSelectItem() {
    this.isShowModalProductModal = true;
    this.txtSearchProductCode = "";
    this.txtSearchProductName = "";
    this.txtSearchProductLicensePlate = "";
    this.txtSearchProductChassisNo = "";
    await this.LoadProductList("Y");

    $('#ModalProductSelectServiceDeliveryDetail').modal('show');
  }

  async LoadProjectSaleQuotationList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['ProjectSaleID'] = this.ServiceDeliveryBacklogID
        objectjson['ProjectSaleQuotationActiveFlag'] = "Y"

      const response = await this.httpClient.post<any>(
        this.baseurl + "ProjectSaleQuotation/GetProjectSaleQuotation",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ProjectSaleQuotationList = response;

      if (this.ProjectSaleQuotationList.length > 0) {
        //console.log('ProjectSaleQuotationList!!!', this.ProjectSaleQuotationList); //
      } 

      this.totalPages = Math.ceil(this.totalItems / environment.PageSize);
      
    } catch (error) {
      console.error('Error loading projectsale quotation:', error);
      alert('An error occurred while loading projectsale quotation data. Please try again.');
    } finally {
      //
    }
  }

async ddlProjectSaleQuotationCodeChange(event: Event): Promise<void> {
  const raw = (event.target as HTMLSelectElement).value;
  let selectedQuotationNo: string | null = null;
  this.showQuotationChanged = true;

  if (raw.includes(': ')) {
    const parts = raw.split(': ');
    if (parts.length > 1) {
      selectedQuotationNo = parts.slice(1).join(': ');
    }
  } else {
    selectedQuotationNo = raw;
  }

  const priceCtrl = this.form.get('ServiceDeliveryBacklogDetailPrice');

  if (!selectedQuotationNo || selectedQuotationNo === 'Please Select') {
    // เคลียร์ค่า แล้วให้ validate ทันที
    priceCtrl?.markAsUntouched();
    priceCtrl?.setValue(null, { emitEvent: false });
    priceCtrl?.markAsTouched();
    priceCtrl?.updateValueAndValidity();
    this.maxAllowedQuotationPrice = 0;
    this.hidProjectSaleQuotationID = null;
    this.QuotationPriceShow = 0;
    this.showQuotationChanged = false;
    return;
  }

  console.log("showQuotationChanged", this.showQuotationChanged)

  const selected = this.ProjectSaleQuotationList
    .find(x => x.ProjectSaleQuotationNo === selectedQuotationNo);

  if (selected) {
    await this.getRemainingQuotationPrice(this.ServiceDeliveryBacklogProjectSaleCode, selected.ProjectSaleQuotationNo);
    await this.getRemainingQuotationDetailNewBusiness(this.ServiceDeliveryBacklogProjectSaleCode, selectedQuotationNo!);

    const formatted = this.formatPrice(selected.ProjectSaleQuotationPrice);
    priceCtrl?.setValue(formatted, { emitEvent: false });

    // ** control & dirty force *ngIf="…touched" work
    priceCtrl?.markAsTouched();
    priceCtrl?.markAsDirty();
    priceCtrl?.updateValueAndValidity();

    this.hidProjectSaleQuotationID = selected.ProjectSaleQuotationID;
    this.QuotationPriceShow = selected.ProjectSaleQuotationPrice ?? 0;
    this.showQuotationChanged = true;
  } else {
    // Clear + validate
    priceCtrl?.setValue(null, { emitEvent: false });
    priceCtrl?.markAsUntouched();
    priceCtrl?.markAsTouched();
    priceCtrl?.updateValueAndValidity();
    this.showQuotationChanged = false;
    this.maxAllowedQuotationPrice = 0;
  }
}
  parseFormattedPrice(formattedPrice: string): number {
    // Clear , and convert
    const cleaned = formattedPrice.replace(/,/g, '');
    return parseFloat(cleaned);
  }

  maxQuotationPriceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const price = control.value; // This is come from ServiceDeliveryBacklogDetailPrice
    const maxPrice = this.maxAllowedQuotationPrice; 

    if (maxPrice === null || price === null || price === undefined || price === '') {
      return null;
    }

    // แปลงราคาเป็นตัวเลข (ใช้ parseFormattedPrice() ของคุณที่มีอยู่แล้ว)
    let parsedPrice: number;
    if (typeof price === 'string') {
        parsedPrice = this.parseFormattedPrice(price);
    } else {
        parsedPrice = price;
    }

    if (parsedPrice > maxPrice) {
      // ถ้าเกินค่าสูงสุดที่อนุญาต ให้ส่ง Error กลับไป
      return { maxQuotationPriceExceeded: { max: maxPrice, actual: parsedPrice } };
    }
    return null; // ถ้าไม่เกิน
  };
}

  async getRemainingQuotationPrice(projectSaleCode: string, quotationNo: string): Promise<void> {

    try {
      const auth_token = await this.TokenService.RefreshToken();
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const requestBody: ServiceDeliveryBacklogDetailInfo = {
        ServiceDeliveryBacklogDetailProjectSaleCode: projectSaleCode,
        ProjectSaleQuotationNo: quotationNo,
        CurrentEditingBacklogId: this.isOnUpdate ? this.form.get('ServiceDeliveryBacklogDetailID')?.value : null
      } as ServiceDeliveryBacklogDetailInfo;

      console.log('Calling GetTotalRemainQuotationPrice with payload:', requestBody);

      const response = await this.httpClient.post<ServiceDeliveryBacklogDetailInfo[]>(
        this.baseurl + "ServiceDeliveryBacklog/GetTotalRemainQuotationPrice",
        JSON.stringify(requestBody),
        httpOptions
      ).toPromise(); // <<-- ใช้ .toPromise() ตรงนี้แทน

      console.log('Response from GetTotalRemainQuotationPrice:', response);

      if (response && response.length > 0) {
        const result = response[0];
        this.maxAllowedQuotationPrice = result.TotalReamainSumPriceForQuotation ?? 0;
        console.log(`Updated maxAllowedQuotationPrice (Remaining Allowed Price): ${this.maxAllowedQuotationPrice}`);
      } else {
        this.maxAllowedQuotationPrice = 0;
        console.warn('No remaining quotation price received or TotalReamainSumPriceForQuotation is null.');
      }
    } catch (error) {
      console.error('Error in getRemainingQuotationPrice:', error);
      this.maxAllowedQuotationPrice = 0;
      alert('Failed to fetch remaining quotation price. Please try again.');
    } finally {
    }
  }

  async getRemainingQuotationDetailNewBusiness(projectSaleCode: string, quotationNo: string) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['ServiceDeliveryBacklogDetailProjectSaleCode'] = projectSaleCode
        objectjson['ProjectSaleQuotationNo'] = quotationNo
        objectjson['ServiceDeliveryBacklogDetailDeliveryStatus'] = "2"

      const response = await this.httpClient.post<any>(
        this.baseurl + "ServiceDeliveryBacklog/GetTotalQuotationDeliveryByStatus",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.TotalBacklogDetailDeliveredQuotationList = response;

      if (this.TotalBacklogDetailDeliveredQuotationList.length > 0) {
        //console.log('TotalBacklogDetailDeliveredQuotationList!!!', this.TotalBacklogDetailDeliveredQuotationList); 
        this.DeliveredPriceShow = this.TotalBacklogDetailDeliveredQuotationList[0].ServiceDeliveryBacklogDetailPrice
      } else {
        this.DeliveredPriceShow = 0;
      }
      
    } catch (error) {
      console.error('Error get Total Delivered Backlog Detail:', error);
      alert('An error occurred whilr Total Delivered Backlog Detail data. Please try again.');
    } finally {
      //
    }
  }

  async LoadProductList(bySearch: string | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberPrduct = 1;
      }

      const objectjson = {
        ProductCode: this.checkUndefinedString(this.txtSearchProductCode?.trim()),
        ProductName: this.checkUndefinedString(this.txtSearchProductName?.trim()),
        ProductLicensePlate: this.checkUndefinedString(this.txtSearchProductLicensePlate?.trim()),
        ProductChassisNo: this.checkUndefinedString(this.txtSearchProductChassisNo?.trim()),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberPrduct - 1) < 0 ? 0 : (this.currentPageNumberPrduct - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Product/GetProductList", 
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ProductList = response;
      this.totalItems = this.ProductList.length;

      if (this.ProductList.length <= 0) {
        this.currentPageNumberPrduct = 0;
      } else {
        if (this.currentPageNumberPrduct == 0) this.currentPageNumberPrduct = 1;
        this.totalItems = Number(this.ProductList[0].itemTotal);
      }

      this.totalPagesProduct = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading product:', error);
      alert('An error occurred while loading product data. Please try again.');
    } finally {
    }
  }

  OnLoadProductList(target = null) {
    if (target != null) {
      this.currentPageNumberPrduct = target.currentPageNumber;
      this.totalPagesProduct = target.totalPages;
    }

    this.LoadProductList();
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  btnClick_SearchProductList() {
    this.LoadProductList("Y");
  }

  ClearSearchProduct() {
    this.isShowModalProductModal = true;
    this.txtSearchProductCode = "";
    this.txtSearchProductName = "";
    this.txtSearchProductLicensePlate = "";
    this.txtSearchProductChassisNo = "";
    this.LoadProductList("Y");
  }

  btnClick_selectProduct() {
  const checkboxes = document.getElementsByName('checkboxproduct') as NodeListOf<HTMLInputElement>;

  checkboxes.forEach((cb) => {
    if (cb.checked) {
      const id = Number(cb.value); // convert to number
      const product = this.ProductList.find(p => p.ProductID === id);

      if (product && !this.SelectedProductList.some(p => p.ProductID === id)) {
        // วิธี declare (แนะนำ) - ชัดเจน อ่านง่าย
        const newProduct = { 
          ...product,
          ProductAmount: 1
        };
        this.SelectedProductList.push(newProduct);
        this.onAmountChanged(newProduct);
        
        // เทียบกับวิธีไม่ declare - ยาวกว่า อ่านยากกว่า
        // this.SelectedProductList.push({ ...product, ProductAmount: 1 });
        // this.onAmountChanged(this.SelectedProductList[this.SelectedProductList.length - 1]);
      }

      // Old Code static pick and amount = 1 in productamount but no call calculate formular at frist
      // if (product && !this.SelectedProductList.some(p => p.ProductID === id)) {
      //   // Get product data object & push into SelectedProductList
      //   this.SelectedProductList.push({ ...product,
      //     ProductAmount: 1
      //    }); // use spread prevent side effect
      // }
      // Old Code static pick and amount = 1 in productamount but no call calculate formular at frist

      // Prepare Code dynamci pick and group productid and auto sum amount = amount + 1 in productamount
      // if (product) {
      //   const existing = this.SelectedProductList.find(p => p.ProductID === id);

      //   if (existing) {
      //     existing.ProductAmount = (existing.ProductAmount || 1) + 1;
      //   } else {
      //     this.SelectedProductList.push({
      //       ...product,
      //       ProductAmount: 1
      //     });
      //   }
      // }
      // Prepare Code dynamci pick and group productid and auto sum amount = amount + 1 in productamount
    }
  });

  ($('#ModalProductSelectServiceDeliveryDetail') as any).modal('hide');
}

  removeSelectedProduct(index: number) {
  this.SelectedProductList.splice(index, 1);
}

  async LoadProjectSaleItemList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['ProjectSaleId'] = this.ServiceDeliveryBacklogID

      const response = await this.httpClient.post<any>(this.baseurl + "ProjectSale/GetProjectSale", JSON.stringify(objectjson), httpOptions
                              ).toPromise();

      this.ProjectSaleItemList = response;

      if (this.ProjectSaleItemList.length > 0) {
        console.log('ProjectSaleItemList', this.ProjectSaleItemList);
        this.ProductCategoryCode = this.ProjectSaleItemList[0].ProjectSaleAssetCategoryCode;
        this.ProductTypeCode = this.ProjectSaleItemList[0].ProjectSaleAssetTypeCode;

        await this.LoadProjectSaleAssetTypeList();
      }
      
    } catch (error) {
      console.error('Error loading projectsale item:', error);
      alert('An error occurred while loading projectsale item data. Please try again.');
    } finally {
      //
    }
  }

  async LoadProjectSaleAssetTypeList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['AssetCategoryCode'] = this.checkUndefinedString(this.ProductCategoryCode);
        objectjson['AssetTypeCode'] = this.checkUndefinedString(this.ProductTypeCode);

      const response = await this.httpClient.post<any>(this.baseurl + "AssetType/GetAssetType", JSON.stringify(objectjson), httpOptions
                              ).toPromise();

      this.ProjectSaleAssetTypeList = response;

      if (this.ProjectSaleAssetTypeList.length > 0) {
        console.log('ProjectSaleAssetTypeList', this.ProjectSaleAssetTypeList);
        this.ProductGroupShow = this.ProjectSaleAssetTypeList[0].AssetGroupName;
        this.ProductCategoryShow = this.ProjectSaleAssetTypeList[0].AssetCategoryName;
        this.ProductTypeShow = this.ProjectSaleAssetTypeList[0].AssetTypeName;
      }
      
    } catch (error) {
      console.error('Error loading projectsale asset:', error);
      alert('An error occurred while loading projectsale asset data. Please try again.');
    } finally {
      //
    }
  }

  onAmountChanged(item: any) {
  item.ProductAmount = Number(item.ProductAmount);

  if (isNaN(item.ProductAmount) || item.ProductAmount < 1) {
    item.ProductAmount = 1;
  }

  const price = item.ProductPrice ?? 0;
  const amount = item.ProductAmount;
  const bv = item.ProductBV ?? 0;

  item.ProductNetAmount = price * amount;
  item.ProductProfit = item.ProductNetAmount - (bv * amount);
}








 // async CalculateAcutalPriceAvailable(projectsaleCode) {
  //   try {
  //     const auth_token = await this.TokenService.RefreshToken();
  //     if (!auth_token) {
  //       console.error('No valid token');
  //       return;
  //     }

  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${auth_token}`
  //       })
  //     };

  //     const objectjson = {
  //       ServiceDeliveryBacklogDetailProjectSaleCode: projectsaleCode,
  //       CurrentEditingBacklogId: this.currentEditingBacklogId
  //     };

  //     console.log('ProjectSaleCode', projectsaleCode);

  //     const response = await this.httpClient.post<ServiceDeliveryBacklogDetailInfo[]>(
  //       this.baseurl + "ServiceDeliveryBacklog/GetBacklogDifference",
  //       JSON.stringify(objectjson),
  //       httpOptions
  //     ).toPromise();

  //     console.log('response', response);
  //     this.BacklogDetailAvailablePriceList = response;

  //     if (this.BacklogDetailAvailablePriceList.length > 0) {
  //       const diffPrice = this.BacklogDetailAvailablePriceList[0].ServiceDeliveryBacklogDetailBacklogDiff?? 0;
  //       this.maxAllowedPrice = diffPrice; // for check allow price!!
  //       //this.maxAllowedPriceShow = diffPrice;

  //       //const formatted = this.formatPrice(diffPrice);
  //       //this.form.patchValue({ ServiceDeliveryBacklogDetailPrice: formatted });

  //       // *** Force ServiceDeliveryBacklogDetailPrice to re validate ***
  //       this.form.get('ServiceDeliveryBacklogDetailPrice')?.updateValueAndValidity();
  //     } else {
  //       // if null set maxAllowedPrice = 0
  //       this.maxAllowedPrice = 0;
  //       //this.form.patchValue({ ServiceDeliveryBacklogDetailPrice: this.formatPrice(0) });
  //       this.form.get('ServiceDeliveryBacklogDetailPrice')?.updateValueAndValidity();
  //     }
  //   } catch (error) {
  //     console.error('Error loading service delivery backlog detail:', error);
  //     alert('An error occurred while loading service delivery backlog detail data. Please try again.');
  //   } finally {
  //     this.loading = false;
  //   }
    
  // }

  // maxPriceValidator(): ValidatorFn {
  //   // Function return as ValidatorFn Type
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //   // 1. Validate null or empty
  //   if (control.value === null || control.value === '') {
  //     return null;
  //   }

  //   let inputValue: number = 0; 

  //   // 2. *** Fix Type error
  //   // Check control.value => string หรือ number
  //   if (typeof control.value === 'string') {
  //     // if string estimate user input or formatted
  //     // call parseFormattedPrice to clear comma & convert to number
  //     inputValue = this.parseFormattedPrice(control.value);
  //   } else if (typeof control.value === 'number') {
  //     // if number to continue (no comma)
  //     inputValue = control.value;
  //   } else {
  //     return null;
  //   }

  //   // 3. Validate:
  //   if (inputValue > this.maxAllowedPrice) {
  //     return { 'maxPriceExceeded': { max: this.maxAllowedPrice, actual: inputValue } };
  //   }
  //     return null; 
  //   };
  // } 

  // async getActualRemainingPriceForDisplay(projectSaleCode: string): Promise<void> {
//     try {
//       const auth_token = await this.TokenService.RefreshToken();
//       if (!auth_token) {
//         console.error('No valid token for display price calculation.');
//         return;
//       }

//       const httpOptions = {
//         headers: new HttpHeaders({
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${auth_token}`
//         })
//       };

//       const requestObject = {
//         ServiceDeliveryBacklogDetailProjectSaleCode: projectSaleCode
//       };

//       console.log('Calling GetTotalRemainingPriceForDisplay with ProjectSaleCode:', projectSaleCode);

//       const response = await this.httpClient.post<ServiceDeliveryBacklogDetailInfo[]>(
//         this.baseurl + "ServiceDeliveryBacklog/GetTotalRemainPriceByDisplay", // <<--- API Endpoint ใหม่
//         JSON.stringify(requestObject),
//         httpOptions
//       ).toPromise();

//       //console.log('Response from GetTotalRemainingPriceForDisplay:', response);

//       if (response && response.length > 0) {
//         this.maxAllowedPriceShow = response[0].ServiceDeliveryBacklogDetailBacklogDiff ?? 0;
//         //console.log(`Updated maxAllowedPriceShow (Display Price): ${this.maxAllowedPriceShow}`);
//       } else {
//         this.maxAllowedPriceShow = 0;
//         console.warn('No display price received from GetTotalRemainingPriceForDisplay.');
//       }
//     } catch (error) {
//       console.error('Error in getActualRemainingPriceForDisplay:', error);
//       // ไม่ต้อง alert user ที่นี่ เพราะมันเป็นแค่การอัปเดต UI
//     }
//   }


}
